<template>
  <div class="content_act" style="position:relative;" v-loading="loading">

    <div class="clearfix">
      <h3 class="ti01 fl">审批意见</h3>
      <div class="fr posr quote mr20">
        <el-button type="text" v-if="canCancaLApproval&&taskEventData.isTask&&taskEventData.curTaskIsFirst" @click="cancelApproval" style="margin-right:20px;font-size:16px;">取消审批</el-button>
        <a href="javascript:void(0)" @click="ACT_viewHistory">
          <i class="iconfont icon-lishi"></i>
          <span>查看历史记录</span>
        </a>
      </div>
    </div>
    <div class="pop pop-history" :style="{display: showHistory}">
      <div class="pop-title">
        <h3 class="fl">审批意见历史记录详情</h3>
        <a href="javascript:void(0)" @click="ACT_closeHistory" class="fr close-history">
          <i class="iconfont icon-close"></i>
        </a>
      </div>
      <div class="pop-con">
        <div class="tb-box" style="overflow-y:auto;max-height:300px;">
          <table class="tb">
            <thead>
              <tr>
                <th class="wp15 tac">时间</th>
                <th class="wp15 tac">审批人</th>
                <th class="wp15 tac">审批意见</th>
                <th class="tac">意见详情</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="his in workFlowEntity.historyInfo" :key="his.guid" v-loading>
                <td style="text-align:center;">{{his.userTaskEndtime}}</td>
                <td
                  style="text-align:center;"
                  v-if="his.ownerUserName!=null&&his.ownerUserName!=''&&his.ownerUserName!=undefined&&his.ownerUserName!=his.userName"
                >{{his.ownerUserName+" 转 "+his.userName}}</td>
                <td style="text-align:center;" v-else>{{his.userName}}</td>
                <td style="text-align:center;">{{his.userOpinion.split('&')[0]}}</td>
                <td style="text-align:center;">{{his.userOpinion.split('&')[1]}}</td>
              </tr>
              <tr v-if="workFlowEntity.endFlow=='endFlow'">
                <td style="text-align:center;"></td>
                <td style="text-align:center;"></td>
                <td style="text-align:center;">结束</td>
                <td style="text-align:center;"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="btn-box" style="margin:15px 0;">
          <a
            href="javascript:void(0)"
            @click="ACT_closeHistory"
            class="btn btn-gray close-history"
          >关闭</a>
        </div>
      </div>
    </div>
    <ul class="steplist02 clearfix" id="flowMsg">
      <li
        class="step"
        :class="nodeDirectClass(item.userTaskId)"
        v-for="(item,index) in workFlowEntity.userListYes"
        :key="item.userTaskId"
      >
        <em>
          <i class="iconfont icon-messagesuccess"></i>
        </em>
        <div class="icon-btn">
            <span class="mr5">{{item.userTitle}}</span><br>
        </div>
        <div class="mb5 exam" v-for="person in item.userList" :key="person.userId">
          <div class="divWidth">
            <span class="mr5">{{person.orgUserGuid}}</span>
          </div>
          <div>
            <span class="mr5">{{person.userName}}</span>
            <span v-if="index==0">起草</span>
            <span
              v-else-if="person.userTaskEndtime=='' || person.userTaskEndtime==null || person.userTaskEndtime==undefined"
            >未审批</span>
            <span v-else-if="person.userComment.length==0">提交审批</span>
            <span v-else>
              <span v-for="opinion in person.userComment" :key="opinion">{{opinion.userOpinion.split('&')[0]}}</span>
            </span>
          </div>
          <div class="c9 fs12">{{person.userTaskEndtime}}</div>
        </div>

        <div class="icon-btn">
          <a
            v-if="nodeDirectClass(item.userTaskId)!='com' && (item.canAdd || item.canAdd=='true' || item.canAdd=='') && taskIdExist"
            href="#"
            class="add-icon ml10"
            title="新增"
            @click="addActiviti(item.userTaskId)"
          >
            <i class="iconfont icon-jia"></i>
          </a>
          <a
            v-if="nodeDirectClass(item.userTaskId)==='' && (item.canModify || item.canModify=='true' || item.canModify=='') && taskIdExist"
            href="#"
            class="add-icon ml10"
            title="编辑"
            @click="editActiviti(item.userTaskId,item.userList)"
          >
            <i class="iconfont icon-icon-edit" :style="{color:item.curNodeEditColor}"></i>
          </a>
          <a
            v-if="nodeDirectClass(item.userTaskId)==='' && (item.canDel=='' || item.canDel=='true') && taskIdExist"
            href="#"
            class="add-icon ml10"
            title="删除"
            @click="delActiviti(item.userTaskId)"
          >
            <i class="iconfont icon-jian"></i>
          </a>
        </div>
      </li>
      <li :class="{com: workFlowEntity.endFlow==='endFlow'}" class="step endFlow">
        <em>
          <i class="iconfont icon-messagesuccess"></i>
        </em>
        <div>
          <span class="mr5">结束</span>
        </div>
      </li>
    </ul>
    <div id="flowRefundMsg" style="display:none;"></div>
    <div class="tb-box02" id="flowOpintion" v-if="taskIdExist">
      <div style="width:100%;">
        <div
          v-bind:class="{aaa: !isTransfer,no_aaa: isTransfer}"
          class="act_send_t"
          @click="isTransfer = false"
        >本人审批</div>
        <div
          v-if="taskIdExist&&isShowTransfer"
          v-bind:class="{aaa: isTransfer,no_aaa: !isTransfer}"
          class="act_transfer_t"
          @click="isTransfer = true"
        >转他人代批</div>
      </div>
      <table class="tb act_send" v-if="!isTransfer">
        <tbody>
          <tr>
            <th>审批意见</th>
            <td class="w180">
              <div class="ssselect w150">
                <el-select v-model="selectOperationValue" style="width:150px;overlfow:hidden;">
                  <el-option
                    v-for="item in selectOperation"
                    :value="item.value"
                    :label="item.name"
                    :key="item.value"
                  ></el-option>
                </el-select>
              </div>
            </td>
            <th>审批时间</th>
            <td id="tdTime">{{nowDate}}</td>
            <th>审批人</th>
            <td>{{oguName}}</td>
          </tr>
          <tr>
            <th>意见详情</th>
            <td colspan="5">
              <el-input type="textarea" :rows="2" placeholder="请输入意见（注意，意见内容请勿包含&字符）" v-model="comment"></el-input>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="tb act_transfer" v-if="isTransfer">
        <tbody>
          <tr id="canTransfer">
            <th>
              <span class="ck-rd">
                <label for="if">代批人</label>
              </span>
            </th>
            <td>
              <div class="tal fl" id="zhuanqian_txt"></div>
              <input type="hidden" name="zhuanqian" id="zhuanqian" />
              <a href="javascript:void(0)" class="fr" id="transferUser" @click="transferActiviti()">
                <i class="iconfont icon-tianjiaren"></i>
              </a>
            </td>
            <td colspan="4"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="btn-box" id="flowBtn" >
       <a href="javascript:void(0)" @click="saveFormData" v-if="showSaveButtonVal" class="btn" id="btnOk">
          <i class="iconfont icon-save"></i>
          <span>保存</span>
        </a>
        <a href="javascript:void(0)" v-if="taskIdExist" @click="ACT_confirm" class="btn" id="btnOk">
          <i class="iconfont icon-wancheng"></i>
          <span> {{confirmTxt}}</span>
        </a>

        <a href="javascript:void(0)" v-if="isReCall" class="btn btn-gray" id="btnCallBack" @click="ACT_recall">
          <i class="iconfont icon-shangyibu"></i>
          <span>撤回</span>
        </a>
    </div>
    <!-- <div class="btn-box" id="flowCallBack" v-if="isReCall">   </div> -->
    <el-dialog

    :close-on-click-modal="false"
    :visible.sync="showSelectPerson" :append-to-body="true" title="选择人员" width="45%">
     <WorkFlowOrgPersonSelectList
        :parentId="parentId"
        :initValue="selectPersonValue"
        :multipleSelect="multipleSelect"
        :expandKeys="defaultExpandKeys"
        @getSelectValue="getSelectPersonValue"
        @showOrgPerson="showOrgPersonFunction"
        @confirmSelectPerson="confirmSelectPerson"
      ></WorkFlowOrgPersonSelectList>
    </el-dialog>
    <el-dialog

    :close-on-click-modal="false"
     :visible.sync="showRefund" :append-to-body="true" title="选择驳回的节点" width="30%">
      <el-radio
        v-model="reFundSid"
        v-for="(reject,index) in this.workFlowReFundList"
        :key="reject.userTaskId"
        :label="reject.userTaskId"
      >
        <div
          v-for="person in reject.userList"
          :key="person.userId"
          class="mb5 exam"
          style="float:left;margin:0 10px 0 0;"
        >
          <div v-for="comment in person.userComment" :key="comment">
            <span class="mr5">{{person.userName}}</span>
            <span v-if="index==0">起草</span>
            <span
              v-else-if="person.userTaskEndtime=='' || person.userTaskEndtime==null || person.userTaskEndtime==undefined"
            >未审批</span>
            <span v-else-if="person.userComment.length==0">提交审批</span>
            <span v-else>
              <span v-for="opinion in person.userComment" :key="opinion">{{opinion.userOpinion.split('&')[0]}}</span>
            </span>
          </div>
        </div>
      </el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showRefund = false">取消</el-button>
        <el-button type="primary" @click="confirmReject">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Cookie from 'js-cookie'
import DateUtils from "@/plugins/DateUtils.vue";
//引入组织人员组件
import WorkFlowOrgPersonSelectList from "../plugins/WorkFlowOrgPersonSelectList";
export default {
  data() {
    return {
      parentId:"50020020",//50020020 集团  50652940 审计监察总部
      showRefund: false, //是否显示驳回窗口
      reFundSid: "", //驳回的sid
      loading: true,
      showSelectPerson: false, //是否显示选人弹窗
      selectPersonValue: [], //选人弹窗的默认人员传入
      multipleSelect: true, //选人弹窗是否多选
      defaultExpandKeys: ["50652940"], //选人弹窗默认展开的节点
      nodeOperation: "", //add edit
      nodeOperationSid: "", //操作节点sid
      isTransfer: false, //是否转签操作
      isShowTransfer:false,//是否显示转签操作
      showHistory: "none", //是否显示审批历史
      workFlowEntity: [], //工作流实体对象存放
      selectOperationValue: "agreeSubmit", //默认的意见操作
      oguName: "", //当前审批人
      orgUserGuid: "", //当前审批人工号
      nowDate: "", //当前时间
      comment: "", //当前审批人具体意见
      taskId: "", //当前用户在此工作流的任务ID（如果没有任务，为空）
      showSaveButtonVal:false,//是否显示保存按钮
      deployWorkFlow:true,//是否在获取时部署
      confirmTxt:"确定",
      taskEventData:{},
      hasBS:'',
      currTaskSidNum: "",
      userListYesNum: "",
      secondNode: false, // 后端返回是否为第2节点
      reFundFast: false, // 前端判断是否可快速驳回
      reFundFastSid: "",
    };
  },
  computed: {
    //操作意见
    selectOperation:function(){
       if(this.workFlowEntity.startUserTaskSid==this.workFlowEntity.currUserTaskSid){
         return [
        { value: "agreeSubmit", name: "同意并送签" }
      ];
       }else{
          return [
        { value: "agreeSubmit", name: "同意并送签" },
        { value: "disagreeReject", name: "不同意并驳回" },
      ];
       }

    },
    //是否当前用户的任务
    taskIdExist: function () {
      if (
        this.taskId != null &&
        this.taskId != "" &&
        this.taskId != undefined
      ) {
        return true;
      } else {
        return false;
      }
    },
    //是否显示撤回按钮
    isReCall: function () {
      try {
        let firstUGuid = this.workFlowEntity.userListYes[0].userList[0].userId;
        let uGuid = this.workFlowEntity.uGuid;
        if (
          uGuid == firstUGuid &&
          this.workFlowEntity.endFlow == "" &&
          this.workFlowEntity.currUserTaskSid !=
            this.workFlowEntity.startUserTaskSid
        ) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    isShowTransfer: function () {
      try {
        let currUserTaskSid = this.workFlowEntity.currUserTaskSid;
        let startUserTaskSid = this.workFlowEntity.startUserTaskSid;
        if (currUserTaskSid!=startUserTaskSid) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    //驳回可选择的节点
    workFlowReFundList: function () {
      let reFundList = [];
      try {
        for (let i = 0; i < this.workFlowEntity.userListYes.length; i++) {
          if(this.workFlowEntity.currUserTaskSid==this.workFlowEntity.userListYes[i].userTaskId){
            break;
          }else{
            reFundList.push(this.workFlowEntity.userListYes[i]);
          }

        }
      } catch (error) {}

      return reFundList;
    },
  },
  props: {
    workFlowGuid: String,
    workFlowFormKey: String,
    taskSubject: String,
    taskUrl: String,
    workFlowFormVar:{
      type:Object,
      default:{}
    },
    workFlowFormData:{
      type:Object,
      default:{}
    },
    showSaveButton:{
      type:Boolean,
      default:false
    },
    canCancaLApproval:{
      type:Boolean,
      default:false
    }
  },
  created() {},
  mounted() {
    this.ACT_getWorkFlow();
  },
  methods: {
    //保存表单数据回调
    saveFormData(){
       this.$emit("saveFormData",true);
    },
    //确认驳回操作
    confirmReject() {
      this.$axios
        .post(
          "/api/activiti/v0.1/workflow/operationReject",
          this.$qs.stringify({
            businessKey: this.workFlowGuid,
            taskId: this.taskId,
            toactusertasksid: this.reFundSid,
            comment: this.comment,
          })
        )
        .then(async (res) => {
          var js = res.data;
          if (js.errcode == 0) {
            this.showRefund = false;
            await this.ACT_getWorkFlow();
            let workFlowstatus=js.data.workFlowStatus;
            //驳回后的操作
            this.$emit('sendWorkFlow',workFlowstatus); // 直接修改父组件的属性
            this.showSaveButtonVal = false
            this.loading = false;
          } else {
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error",
            });
          }
        });
        //解决驳回后端处理后 但不返回数据导致前端无反应bug
        setTimeout(()=>{
          if(this.showRefund){
            this.showRefund = false;
            this.ACT_getWorkFlow();
            this.$emit('sendWorkFlow',0); // 直接修改父组件的属性
            this.loading = false;
          }
        },2500)
    },
    //确认驳回操作
    confirmFastReject() {
      this.$axios
        .post(
          "/api/activiti/v0.1/workflow/operationReject",
          this.$qs.stringify({
            businessKey: this.workFlowGuid,
            taskId: this.taskId,
            toactusertasksid: this.reFundFastSid,
            comment: this.comment,
          })
        )
        .then(async (res) => {
          var js = res.data;
          if (js.errcode == 0) {
            this.showRefund = false;
            await this.ACT_getWorkFlow();
            let workFlowstatus=js.data.workFlowStatus;
            //驳回后的操作
            this.$emit('sendWorkFlow',workFlowstatus); // 直接修改父组件的属性
            this.showSaveButtonVal = false
            this.loading = false;
          } else {
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error",
            });
          }
        });
        //解决驳回后端处理后 但不返回数据导致前端无反应bug
        setTimeout(()=>{
          // if(this.showRefund){
            this.showRefund = false;
            this.ACT_getWorkFlow();
            this.$emit('sendWorkFlow',0); // 直接修改父组件的属性
            this.loading = false;
          // }
        },2500)
    },
    showOrgPersonFunction(val){
      this.showSelectPerson=val;
    },
    //取消流程
    cancelApproval(){
      this.$emit('cancelApproval',this.workFlowGuid)
    },
    //默认节点选择的人
    getSelectPersonValue(val) {
      this.selectPersonValue = val;
    },
    //获取传入节点在当前任务节点前后的位置
    nodeDirectClass(sid) {
      if (this.workFlowEntity.endFlow == "endFlow") return "com";
      let arr = new Array();
      for (let i = 0; i < this.workFlowEntity.userListYes.length; i++) {
        arr.push(this.workFlowEntity.userListYes[i].userTaskId);
      }
      let sidIndex = arr.indexOf(sid);
      let currIndex = arr.indexOf(this.workFlowEntity.currUserTaskSid);
      if (sidIndex < currIndex) {
        return "com";
      } else if (sidIndex == currIndex) {
        return "curstep";
      } else {
        return "";
      }
    },
    //获取工作流
    ACT_getWorkFlow() {
      if(!this.workFlowGuid||!this.workFlowFormKey){
        this.loading=false;
        return;
      }

      this.$axios
        .get("/api/activiti/v0.1/workflow/getWorkFlow",{
          params:{
            businessKey:this.workFlowGuid,
            formKey:this.workFlowFormKey,
            formVar:JSON.stringify(this.workFlowFormVar),
          }
        })
        .then(async (res) => {
          var js = res.data;

          if (js.errcode == 0) {
            this.workFlowEntity = js.data;
            this.workFlowEntity.userListYes = this.workFlowEntity.userListYes.map(item=>{
              let arr = new Array();
              for (let i = 0; i < this.workFlowEntity.userListYes.length; i++) {
                arr.push(this.workFlowEntity.userListYes[i].userTaskId);
              }
              let sidIndex = arr.indexOf(item.userTaskId);
              let currIndex = arr.indexOf(this.workFlowEntity.currUserTaskSid);
              if(sidIndex - currIndex == 1&&((!item.userList)||item.userList.length<1)){
                item.curNodeEditColor = 'red'
              }
              return item
            })
            this.oguName = this.workFlowEntity.userInfo.oguName;
            this.orgUserGuid = this.workFlowEntity.userInfo.orgUserGuid;
            this.nowDate = this.workFlowEntity.nowDate;
            this.taskId = this.workFlowEntity.taskId;
            this.currTaskSidNum = this.workFlowEntity.currTaskSidNum;
            this.userListYesNum = this.workFlowEntity.userListYesNum;
            this.secondNode = this.workFlowEntity.secondNode;
            this.reFundFastSid = this.workFlowEntity.reFundSid;
            if(js.data.workFlowStatus==0){
              this.confirmTxt="提交";
            }
            if(!js.data.beCurrUser && js.data.workFlowStatus==0) {
                this.$emit('workFlowStatus', -1); // 把工作流状态传给父组件
            } else {
                this.$emit('workFlowStatus', js.data.workFlowStatus); // 把工作流状态传给父组件
            }

            this.$emit('workFlowNode',js.data.userListYes,js.data.currUserTaskSid,js.data.uGuid,js.data.workFlowStatus);
            let allApprovalUserIds = []
              js.data.userListYes.forEach((item,index)=>{
                if(index!=0){
                  item.userList.forEach(item1=>{
                    allApprovalUserIds.push(item1.userName)
                  })
                }
              })
            this.taskEventData.allApprovalUserIds=allApprovalUserIds
            this.taskEventData.workFlowStatus = js.data.workFlowStatus
            let curName = Cookie.get('oguName')
            this.taskEventData.firstTaskUser=js.data.userListYes[0].userList[0].userName == curName
            let curTask = js.data.userListYes.find((item,index)=>{
                return item.nodeNum == js.data.currTaskSidNum
            })
            this.taskEventData.curTaskTitle = (curTask?curTask.userTitle:'')
            this.taskEventData.curTaskIsFirst = js.data.currUserTaskSid == js.data.startUserTaskSid
            this.taskEventData.isTask = js.data.taskId?true:false
            this.taskEvent()
            this.loading = false;
          } else if (js.errcode == 102) {
            //没有此流程就部署流程
            if(this.deployWorkFlow&&this.hasBS!=this.workFlowGuid){
              // this.hasBS = this.workFlowGuid
             await this.ACT_Deploy();
            }

          } else {
            this.loading = false;
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error",
            });
          }
        });
    },
    taskEvent(){
      this.taskEventData.showSaveButton=this.showSaveButtonVal
      this.$emit('taskEvent',this.taskEventData)
      //当前节点信息

    },
    //部署工作流
    ACT_Deploy() {
      //此变量定义勿动
      let subject={
          "taskSubject":this.taskSubject,
          "taskUrl":this.taskUrl
         }

      let json=new Object;
      json.subject=JSON.stringify(subject);
      if(this.workFlowFormVar){
          for (var key in this.workFlowFormVar)
          {
              json[key]=this.workFlowFormVar[key];
          }
      }
      //deploy url
      let deployUrl="/api/activiti/v0.1/workflow/deploy?tenant=portal"
                    +"&businessKey="+this.workFlowGuid
                    +"&formKey="+this.workFlowFormKey;
      //变量存放
      this.$axios
        .post(deployUrl, json)
        .then(async (res) => {
          var js = res.data;
          if (js.errcode == 0) {
            await this.ACT_getWorkFlow();
            this.loading = false;
          } else {
            this.loading = false;
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error",
            });
          }
        });
    },
    //显示审批历史记录
    ACT_viewHistory() {
      this.showHistory = "";
    },
    //关闭审批历史记录
    ACT_closeHistory() {
      this.showHistory = "none";
    },
    //添加节点
    addActiviti(sId) {
      this.selectPersonValue = [];
      this.nodeOperation = "add";
      this.nodeOperationSid = sId;
      this.showSelectPerson = true;
    },
    //通过节点下标编辑节点
    editActivitiByIndex(index,selectUser){
      if(this.workFlowEntity.userListYes[index]){
        this.selectPersonValue = selectUser;
        let sId = this.workFlowEntity.userListYes[index].userTaskId
        let userList = this.workFlowEntity.userListYes[index].userList
        let arr = new Array();
        if (userList != null) {
          for (let i = 0; i < userList.length; i++) {
            arr.push(userList[i].userId);
          }
        }
        arr.push(...selectUser)
        this.selectPersonValue = Array.from(new Set(arr));
        this.nodeOperation = "edit";
        this.nodeOperationSid = sId;
        this.confirmSelectPerson()
      }else{
        console.log('代码错误')
      }
    },
    //编辑节点
    editActiviti(sId, userList) {
      let arr = new Array();
      if (userList != null) {
        for (let i = 0; i < userList.length; i++) {
          arr.push(userList[i].userId);
        }
      }
      this.selectPersonValue = arr;
      this.nodeOperation = "edit";
      this.nodeOperationSid = sId;
      this.showSelectPerson = true;
    },
    //删除节点
    delActiviti(sId) {
      this.$confirm("你确认要删除吗?", "提示", {})
        .then(() => {
          this.$axios
            .post(
              "/api/activiti/v0.1/workflow/deleteUser",
              this.$qs.stringify({
                businessKey: this.workFlowGuid,
                actUserTaskId: sId,
              })
            )
            .then(async (res) => {
              var js = res.data;
              if (js.errcode == 0) {
                await this.ACT_getWorkFlow();
                this.loading = false;
              } else {
                this.$message({
                  showClose: true,
                  message: js.errmsg,
                  type: "error",
                });
              }
            });
        })
        .catch(() => {});
    },
    //选人人员确认
    confirmSelectPerson() {
      if (
        this.selectPersonValue == null ||
        this.selectPersonValue == "" ||
        this.selectPersonValue == undefined
      ) {
        this.$message({
          showClose: true,
          message: "请选择人员",
          type: "error",
        });
        return;
      }

      if (this.nodeOperation == "add") {
        //加人操作
        this.$axios
          .post(
            "/api/activiti/v0.1/workflow/addUser",
            this.$qs.stringify({
              businessKey: this.workFlowGuid,
              actUserTaskId: this.nodeOperationSid,
              assignee: this.selectPersonValue.join(","),
            })
          )
          .then(async(res) => {
            var js = res.data;
            if (js.errcode == 0) {
              await this.ACT_getWorkFlow();
              this.loading = false;
            } else {
              this.$message({
                showClose: true,
                message: js.errmsg,
                type: "error",
              });
            }
          });
        this.showSelectPerson = false;
      } else if (this.nodeOperation == "edit") {
        //编辑操作
        this.$axios
          .post(
            "/api/activiti/v0.1/workflow/updateUser",
            this.$qs.stringify({
              businessKey: this.workFlowGuid,
              actUserTaskId: this.nodeOperationSid,
              assignee: this.selectPersonValue.join(","),
            })
          )
          .then(async (res) => {
            var js = res.data;
            if (js.errcode == 0) {
              await this.ACT_getWorkFlow();
              this.loading = false;
            } else {
              this.$message({
                showClose: true,
                message: js.errmsg,
                type: "error",
              });
            }
          });
        this.showSelectPerson = false;
      } else if (this.nodeOperation == "transfer") {
        this.$confirm("你确认要转移任务吗?", "提示", {})
          .then(() => {
            this.$axios
              .post(
                "/api/activiti/v0.1/workflow/transferUser",
                this.$qs.stringify({
                  businessKey: this.workFlowGuid,
                  taskId: this.taskId,
                  touguid: this.selectPersonValue.join(","),
                })
              )
              .then(async(res) => {
                var js = res.data;
                if (js.errcode == 0) {
                  this.showSelectPerson = false;
                  await this.ACT_getWorkFlow();
                  this.loading = false;
                } else {
                  this.$message({
                    showClose: true,
                    message: js.errmsg,
                    type: "error",
                  });
                }
              });
          })
          .catch(() => {});
      }
    },
    //确认送签
    ACT_confirm(comment) {
      if(comment){
        this.comment = comment
      }
      if (!this.taskId) {
        this.$message({
          showClose: true,
          message: "您没有此任务，不能操作。",
          type: "error",
        });
        return;
      }

      //驳回操作判断
      if (this.selectOperationValue == "disagreeReject") {
          if(!this.secondNode) {
              this.showRefund = true
          } else {
              this.reFundFast = true
              this.confirmFastReject()
          }
          return;
      }

      if(this.secondNode && this.reFundFast) {
        this.confirmFastReject()
        return;
      }

      //送签前调用父窗口进行业务校验
      let callWorkFlowFormResult={
        errcode:0,
        errmsg:''
      };
      this.$emit('callWorkFlowForm',true,(val)=>{
        callWorkFlowFormResult=val;
      });
      if(callWorkFlowFormResult.errcode!=0){
        if(callWorkFlowFormResult.errmsg){
        this.$message({
            showClose: true,
            message: callWorkFlowFormResult.errmsg,
            type: "error",
          });
        }
          return;
      }else{
        //送签操作
        this.$axios
          .post(
            "/api/activiti/v0.1/workflow/operationSend",
            this.$qs.stringify({
              businessKey: this.workFlowGuid,
              taskId: this.taskId,
              selectOperation: this.selectOperationValue,
              comment: this.comment,
              formVar:JSON.stringify(this.workFlowFormVar),
              formData:JSON.stringify(this.workFlowFormData),
            })
          )
          .then(async(res) => {

            var js = res.data;
            if (js.errcode == 0||(!js.errmsg)) {
              await this.ACT_getWorkFlow();
              let workFlowstatus=js.data.workFlowStatus;
              //送完后的操作
              this.$emit('sendWorkFlow',workFlowstatus); // 直接修改父组件的属性
              //解决接口报404后不刷新浏览器bug 导致还存在保存按钮
              this.showSaveButtonVal = false
              this.loading = false;
            } else {
              this.$message({
                showClose: true,
                message: js.errmsg,
                type: "error",
              });
            }
          }).catch(err=>{
            console.log('审批报错.....',err);
            if(this.workFlowEntity.currUserTaskSid==this.workFlowEntity.userListYes[this.workFlowEntity.userListYes.length-1].userTaskId){
              //送完后的操作
              this.$emit('sendWorkFlow',1); // 直接修改父组件的属性
              //解决接口报404后不刷新浏览器bug 导致还存在保存按钮
              this.showSaveButtonVal = false
              this.loading = false;
            }
          });
          setTimeout(()=>{
            console.log('审批超时......');
            if(this.loading){
              if(this.workFlowEntity.currUserTaskSid==this.workFlowEntity.userListYes[this.workFlowEntity.userListYes.length-1].userTaskId){
                //送完后的操作
                this.$emit('sendWorkFlow',1); // 直接修改父组件的属性
                //解决接口报404后不刷新浏览器bug 导致还存在保存按钮
                this.showSaveButtonVal = false
                this.loading = false;
              }
            }
          },2500);
      }
    },
    //转签操作
    transferActiviti() {
      this.multipleSelect = false;
      this.selectPersonValue = [];
      this.nodeOperation = "transfer";
      this.showSelectPerson = true;
    },
    //撤回操作
    ACT_recall() {
      this.$confirm("你确认要撤回吗?", "提示", {})
        .then(() => {
          this.$axios
            .post(
              "/api/activiti/v0.1/workflow/callBack",
              this.$qs.stringify({
                businessKey: this.workFlowGuid,
              })
            )
            .then(async (res) => {
              var js = res.data;
              if (js.errcode == 0) {
                 await this.ACT_getWorkFlow();
                 let workFlowstatus=js.data.workFlowStatus;
                 //撤回后的操作
                 this.$emit('sendWorkFlow',workFlowstatus); // 直接修改父组件的属性
                 this.showSaveButtonVal = false
                this.loading = false;
              } else {
                this.$message({
                  showClose: true,
                  message: js.errmsg,
                  type: "error",
                });
              }
            });

            this.setTimeout(()=>{
              if(this.loading){
                this.ACT_getWorkFlow();
                this.$emit('sendWorkFlow',1); // 直接修改父组件的属性
                this.loading = false;
              }
            },2500)
        })
        .catch(() => {});
    },
  },
  filters: {
    formatDate(time) {
      return DateUtils.formatDate(time, "YYYY-MM-DD HH:mm:ss");
    },
  },
  watch:{
    workFlowGuid(){
      this.ACT_getWorkFlow();

    },
    workFlowFormVar:{
      deep:true,
      handler:function(val,old){
        console.log("workFlowFormVar",val)
        //this.deployWorkFlow=false
        if(this.workFlowGuid){
          this.ACT_getWorkFlow();
        }
      }
    },
    showSaveButton(val){
      if(this.taskId){
        this.showSaveButtonVal=val;
        this.$emit('isShowDisabled', this.showSaveButtonVal); //审批人驳回后，没有保存按钮，则设置表单不可编辑
      }else{
         this.showSaveButtonVal=false;
        this.$emit('isShowDisabled', this.showSaveButtonVal); //审批人驳回后，没有保存按钮，则设置表单不可编辑
      }
    },
  },
  //注册组件
  components: {
    WorkFlowOrgPersonSelectList, //组织人员数
  },
};
</script>
<style scoped>
/* @import "../assets/css/mainbody-sj.css"; */
.activiti_opinion {
  width: 140px;
  word-break: break-all;
  display: -webkit-box; /**对象作为伸缩盒子模型展示**/
  -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
  -webkit-line-clamp: 1; /**显示的行数**/
  overflow: hidden; /**隐藏超出的内容**/
}
.content_act {
  background-color: #ffffff;
  padding: 20px;
}
.w150 {
  width: 150px;
}
.el-dialog__title {
  float: left;
}
.aaa {
  float: left;
  padding: 5px 10px 5px 10px;
  cursor: pointer;
  background-color: #499cd3;
  color: #ffffff;
}
.no_aaa {
  padding: 5px 10px 5px 10px;
  float: left;
  cursor: pointer;
  background-color: #22578c;
  color: #ffffff;
}
.divWidth {
  width: 183px;
  overflow: hidden;
}
</style>
